import styled from "styled-components";

const FormContainer = styled.div`
  display: grid;
  background-color: aliceblue;
  padding: 20px 10px;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 30px;
  margin-left: 40px;
  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export default FormContainer;
